import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResponseRateReportDomain = (state) =>
  state.get("widgetResponseRateReportV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectWidgetResponseRateReportDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDivisionsRate = () =>
  createSelector(selectWidgetResponseRateReportDomain, (state) =>
    state.get("divisionsRate")
  )

const makeSelectWidgetResponseRateReport = () =>
  createSelector(selectWidgetResponseRateReportDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResponseRateReport
export { selectWidgetResponseRateReportDomain }
